/**
 * User-visible copy for the auth-reset notifications. Centralised so the
 * inactivity logout, SDK 401 reset, and (future) sidebar logout share
 * one source of truth and translation can target a single module.
 *
 * @agentic connections
 */

/** Reasons the soft auth-reset path runs. @agentic connections */
export type AuthResetReason = "inactivity" | "unauthenticated" | "manual";

/** Notification payload shape consumed by `notifications.show`. @agentic connections */
export type AuthResetNotification = {
  title: string;
  message: string;
  color: string;
  /** `false` keeps the toast up until the user dismisses it; a number sets
   *  an auto-close delay in ms. Omitted = Mantine default. */
  autoClose?: number | false;
};

/** Per-reason notification copy. @agentic connections */
export const AUTH_RESET_NOTIFICATIONS: Record<
  AuthResetReason,
  AuthResetNotification | null
> = {
  inactivity: {
    title: "Signed out for inactivity",
    message: "Please sign in again to continue.",
    color: "yellow",
    // Persist: the user may return long after the auto-logout fired and must
    // still see why they were signed out.
    autoClose: false,
  },
  unauthenticated: {
    title: "Session ended",
    message: "Please sign in again to continue.",
    color: "yellow",
    autoClose: false,
  },
  // Manual sidebar logout is intentional — no toast.
  manual: null,
};
